<template>
  <div>
    <section class="content-header">
      <h1>
        <span>{{$ml.get('shared.scenarioList')}}</span>
      </h1>
      <ol class="breadcrumb">
        <li>
          <i class="fa fa-dashboard"></i>
          <span>{{$ml.get('shared.dashboard')}}</span>
        </li>
        <li>
          <i class="fa fa-book"></i>
          <span>{{$ml.get('shared.definitions')}}</span>
        </li>
        <li>
          <span>{{$ml.get('shared.scenarioList')}}</span>
        </li>
      </ol>
    </section>
    <section class="content">
      <div class="row">
        <div class="col-sm-12">
          <div class="box box-primary">
            <div class="box-header">
              <h3 class="box-title">
                <span>{{$ml.get('shared.scenarioList')}}</span>
              </h3>
              <div class="box-tools pull-right">
                <button @click="newScenario()" class="btn btn-primary pull-right"><i class="fa fa-plus"></i> Yeni Senaryo Oluştur</button>
              </div>
            </div>
            <div class="box-body">
              <div
                v-show="scenarioList.length > 0"
                class="table-responsive no-padding"
                :style="windowHeightSize"
              >
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th>Senaryo Adı</th>
                      <th>Senaryo Tipi</th>
                      <th>Senaryo Gün</th>
                      <th>Senaryo Zaman</th>
                      <th>Komut</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="scenario in scenarioList" :key="scenario.id">
                      <td>
                        <span>{{scenario.name}}</span>
                      </td>
                      <td>
                        <span v-show="scenario.type == 1"><i class="fa fa-clock-o"></i> Zaman Bazlı</span>
                        <span v-show="scenario.type == 2"><i class="fa fa-exclamation-triangle"></i> Olay Bazlı</span>
                      </td>
                      <td>
                        <span v-show="scenario.day == 1">{{$ml.get("general.monday")}}</span>
                        <span v-show="scenario.day == 2">{{$ml.get("general.tuesday")}}</span>
                        <span v-show="scenario.day == 3">{{$ml.get("general.wednesday")}}</span>
                        <span v-show="scenario.day == 4">{{$ml.get("general.thursday")}}</span>
                        <span v-show="scenario.day == 5">{{$ml.get("general.friday")}}</span>
                        <span v-show="scenario.day == 6">{{$ml.get("general.saturday")}}</span>
                        <span v-show="scenario.day == 7">{{$ml.get("general.sunday")}}</span>
                      </td>
                      <td>
                        {{toDateFormat(scenario.time, "ss:dd")}}
                      </td>
                      <td>
                        <span v-show="scenario.command == 1"><i class="fa fa-bell"></i> Alarm Tetikle</span>
                      </td>
                      <td>
                        <button class="btn btn-primary btn-sm" @click="goToDetails(scenario.id)">
                          <i class="fa fa-search"></i>
                        </button>
                        <button class="btn btn-danger btn-sm" @click="deleteScenario(scenario.id)">
                          <i class="fa fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-show="scenarioList.length == 0" class="callout callout-info">
                <i class="fa fa-info-circle"></i> {{$ml.get("alerts.recordNotFound")}}
              </div>
            </div>
            <div class="overlay" id="load" :hidden="!isLoading">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  data(){
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      scenarios: []
    }
  },
  computed: {
    modules() {
      return this.$store.getters.getModules;
    },
    windowHeightSize() {
      if (this.windowHeight) {
        let height = this.windowHeight - 255;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    },
    scenarioList(){
      return this.scenarios;
    }
  },
  watch: {
    windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
        //WEB
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  methods: {
    onResize() {
      this.windowHeight = window.innerHeight;
    },
    toDateFormat(str, format) {
      if (str.length > 9) {
        str = new Date(str);
      } else {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
      }
      if (format == "gg.aa.yyyy ss:dd") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return yil + "-" + ay + "-" + gun;
      } else if (format == "ss:dd:ss") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        var saniye =
          str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
        return saat + ":" + dakika + ":" + saniye;
      } else if (format == "ss:dd") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return saat + ":" + dakika;
      }
    },
    newScenario(){
      this.$router.push("/new-scenario");
    },
    goToDetails(id){
      this.$router.push({
        name: "scenario-details",
        params: { id: id }
      });
    },
    async deleteScenario(id) {
      try {
        this.isLoading = true;
        const response = await this.$axios
          .delete("/Scenario/" + id)
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.getScenarios();
        alertify.success(this.$ml.get("alerts.deletedSuccessfully"));
        this.isLoading = false;
      } catch (error) {
        alertify.error("Hata Oluştu : " + error);
        this.isLoading = false;
      }
    },
    async getScenarios(){
      this.isLoading = true;
      try {
        const response = await this.$axios
          .get("/Scenario")
          .then(response => {
            this.scenarios = response.data;
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoading = false;
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  async created() {
    await this.getScenarios();
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/scenarios/ScenarioList.vue